/* DEZERNOO: swipe a product-card picture on touch screens.
   - Cards with 2+ colours (each with its own picture): swipe right = next colour, left = previous (loop),
     exactly like tapping the swatch (picture, ring, link, quick-add colour). No dots; the swatch ring shows it.
   - Other cards: toggle between the 2 card pictures (loop), with 2 dots.
   Desktop hover is untouched. Cards inside horizontal carousels and quick-add are skipped.
   CSS lives in snippets/dez-card-swipe.liquid (critical, in <head>). */
(function () {
  if (window.__dezCardSwipe || !window.matchMedia || !matchMedia("(hover: none)").matches) return;
  window.__dezCardSwipe = true;

  var SKIP = "items-scroll, items-scroll-paged-navigation, [items-overflow], [items-overflow-max], quick-shop, .swiper";
  var MIN_DX = 30, LOCK = 10;

  function hoverImg(card) { return card.querySelector("img.product-card__img-hover"); }

  // Colours this card can cycle through: visible swatches whose variant has its own, distinct picture.
  function colours(card) {
    if (card._dezCols !== undefined) return card._dezCols;
    var list = null;
    try {
      var js = card.querySelector("script[id^='ProductJson']");
      var p = js ? JSON.parse(js.textContent) : card.product;
      var seen = {}, out = [];
      card.querySelectorAll("product-card-variant-swatch[variant-id]").forEach(function (sw) {
        var id = sw.getAttribute("variant-id"), v = null;
        for (var i = 0; p && i < p.variants.length; i++) if (String(p.variants[i].id) === id) { v = p.variants[i]; break; }
        var m = v && v.featured_media && v.featured_media.preview_image;
        if (!m || !m.src || seen[m.src]) return;
        seen[m.src] = 1; out.push({ sw: sw, img: m });
      });
      if (out.length >= 2) list = out;
    } catch (e) {}
    card._dezCols = list;
    return list;
  }
  function curIndex(card, cols) {
    var a = card.querySelector("product-card-variant-swatch.is-active");
    for (var i = 0; i < cols.length; i++) if (cols[i].sw === a) return i;
    return 0;
  }
  // warm the cache for a colour's picture using the theme's own srcset builder (same URLs)
  function preload(card, c) {
    if (!c || c.pre || typeof card.updateImage !== "function" || !card.image) return;
    var f = c.img.src.split("?")[0].split("/").pop();
    if ((card._dezOrig && card._dezOrig.file === f) || (!card._dezOrig && (card.image.currentSrc || card.image.src).indexOf(f) > -1)) { c.pre = 1; return; } // the picture shown at load is already downloaded
    c.pre = 1;
    // collect the theme's URLs first, then set srcset before src (WebKit fetches a detached image's src at once)
    var at = {}, fake = { setAttribute: function (k, v) { at[k] = v; } };
    try { card.updateImage.call({ image: fake, imageContainerRatio: card.imageContainerRatio, imageFit: card.imageFit }, c.img.src, c.img.width, c.img.height); } catch (e) { return; }
    var tmp = new Image();
    tmp.sizes = card.image.getAttribute("sizes") || "50vw";
    if (at.srcset) tmp.srcset = at.srcset;
    if (at.src) tmp.src = at.src;
  }

  function decorate(card) {
    if (card.hasAttribute("data-dez-swipe-init") || card.hasAttribute("data-dez-swipe-skip")) return;
    var media = card.querySelector(".product-card__media--hover-image");
    if (!colours(card) && (!media || !hoverImg(card))) return; // single-image, single-colour cards stay as they are
    if (card.closest(SKIP)) { card.setAttribute("data-dez-swipe-skip", ""); return; }
    card.setAttribute("data-dez-swipe-init", "");
    if (colours(card)) { card.setAttribute("data-dez-swipe-colours", ""); return; } // swatch ring is the indicator
    var box = media.closest(".o-ratio") || media;
    if (!box.querySelector(".dez-swipe-dots")) {
      var dots = document.createElement("div");
      dots.className = "dez-swipe-dots";
      dots.setAttribute("aria-hidden", "true");
      dots.innerHTML = "<i></i><i></i>";
      box.appendChild(dots);
    }
  }

  var queued = false;
  function scan() {
    queued = false;
    var cards = document.querySelectorAll("product-card");
    for (var i = 0; i < cards.length; i++) decorate(cards[i]);
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }

  var s = null;
  document.addEventListener("touchstart", function (e) {
    s = null;
    if (e.touches.length !== 1 || !e.target.closest) return;
    var card = e.target.closest("product-card");
    if (!card) return;
    if (!card.hasAttribute("data-dez-swipe-init")) { decorate(card); if (!card.hasAttribute("data-dez-swipe-init")) return; }
    if (!e.target.closest(".product-card__media")) return;
    var ctl = e.target.closest("button, quick-shop, .quick-shop__trigger, product-card-button"); // <product-card> itself carries quick-shop-trigger="icon"
    if (ctl && card.contains(ctl)) return;
    var cols = colours(card);
    if (cols) { var k = curIndex(card, cols); preload(card, cols[(k + 1) % cols.length]); preload(card, cols[(k - 1 + cols.length) % cols.length]); }
    else card.setAttribute("data-dez-swipe-armed", ""); // lets the 2nd image start downloading
    var t = e.touches[0];
    s = { card: card, x: t.clientX, y: t.clientY, lx: t.clientX, dir: null };
  }, { passive: true });

  document.addEventListener("touchmove", function (e) {
    if (!s) return;
    var t = e.touches[0];
    s.lx = t.clientX;
    if (s.dir) return;
    var dx = t.clientX - s.x, dy = t.clientY - s.y;
    if (Math.abs(dx) > LOCK || Math.abs(dy) > LOCK) s.dir = Math.abs(dx) > Math.abs(dy) * 1.2 ? "h" : "v";
  }, { passive: true });

  document.addEventListener("touchcancel", function () { s = null; }, { passive: true });

  document.addEventListener("touchend", function (e) {
    if (!s) return;
    var cur = s; s = null;
    var t = e.changedTouches && e.changedTouches[0];
    var dx = ((t && t.clientX) || cur.lx) - cur.x;
    if (cur.dir !== "h" || Math.abs(dx) <= MIN_DX) return;
    var card = cur.card, img = hoverImg(card);
    // a swipe must not open the product (the tap-click that may follow is swallowed)
    card.setAttribute("data-dez-swiped", "");
    setTimeout(function () { card.removeAttribute("data-dez-swiped"); }, 450);
    var cols = colours(card);
    if (cols) {
      // RTL store: swatches run right-to-left, so a finger moving right brings the next colour (like an RTL carousel)
      var step = getComputedStyle(card).direction === "rtl" ? (dx > 0 ? 1 : -1) : (dx < 0 ? 1 : -1);
      var k = (curIndex(card, cols) + step + cols.length) % cols.length;
      var im = card.image || card.querySelector("img.product-card__img");
      if (im && !card._dezOrig) card._dezOrig = { src: im.getAttribute("src"), srcset: im.getAttribute("srcset"), w: im.getAttribute("width"), h: im.getAttribute("height"), file: (im.currentSrc || im.src).split("?")[0].split("/").pop() };
      var o = card._dezOrig;
      if (im && o && cols[k].img.src.split("?")[0].split("/").pop() === o.file) {
        // back to the colour shown at load: select it like a tap, but put back the already-downloaded picture
        card.updateImage = function () {};
        try { cols[k].sw.click(); } finally { delete card.updateImage; }
        im.setAttribute("srcset", o.srcset || ""); im.setAttribute("src", o.src); if (o.w) im.setAttribute("width", o.w); if (o.h) im.setAttribute("height", o.h);
      } else {
        cols[k].sw.click(); // same as tapping the swatch: picture, link, quick-add variant, ring
      }
      preload(card, cols[(k + step + cols.length) % cols.length]);
      return;
    }
    if (!img || !img.classList.contains("hover-enabled")) return; // e.g. swatch made both images equal
    var next = card.getAttribute("data-dez-swipe") === "2" ? "1" : "2";
    var apply = function () { card.setAttribute("data-dez-swipe", next); };
    if (next === "1") return apply();
    var n = 0;
    (function wait() {
      if (img.complete && img.naturalWidth) return apply();
      if (++n < 80) setTimeout(wait, 50);
    })();
  }, { passive: true });

  var SWATCH = "product-card-variant-swatches, product-card-swatches, .js-product-swatch-item";
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    // colour swatch: the theme swaps the main picture, so show the main picture again
    var sw = e.target.closest(SWATCH);
    if (sw) {
      var c = sw.closest("product-card");
      if (c) c.removeAttribute("data-dez-swipe");
      return; // never swallow a swatch tap
    }
    var card = e.target.closest("product-card[data-dez-swiped]");
    if (card) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  scan();
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var added = list[i].addedNodes;
      for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) return queue();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
